module.exports = __webpack_public_path__ + "img/ignis-color.bb328263.svg";